<template>
	<div class="statusList">
		<v-content>
			<v-container fluid>
        <div v-if="isDepartments == true" class="selectDept">
          <v-flex>
            <label class="blackLabel">Select Department:</label>
            <v-select @input="fncFilterStatuses(true)" :items="departmentListNew" v-model="department" item-value="id" item-text="name" label="Select Department" autocomplete solo></v-select>
          </v-flex>
          <br />
        </div>
        <div>
          <v-data-table v-show="fncShowStatusList()" :headers="headers" :search="search" ref="sortableTable" :items="statusList" hide-actions class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
            <template slot="items" slot-scope="props">
              <!--<tr class="sortableRow" id="rows" v-show="props.item.show == true">-->
              <tr class="sortableRow" id="rows" v-if="props.item.show == true">
                <td width="5%" class="px-1">
                  <v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
                </td>
                <td width="30%" v-if="departmentList.length == 0 || objAuthorize.department_active == false || objAuthorize.department_active == 0">{{ props.item.description }}</td>
                <td width="30%" v-else>{{ props.item.description }}</td>
                <td width="20%"  v-if="fncGetPipelineGrouping(props.item)">{{fncGetPipelineGrouping(props.item)}}</td>
                <td width="20%"  v-else><span style="color: red;font-weight: 550;">Not Configured</span></td>
                <!--<td width="15%" v-html="fncGetDepartment(props.item.department)" v-if="departmentList.length != 0 && ( objAuthorize.department_active == true || objAuthorize.department_active == 1 )"></td>-->
                <td width="15%" v-if="departmentList.length != 0 && ( objAuthorize.department_active == true || objAuthorize.department_active == 1 ) && props.item.department == null">N/A</td>
                <td width="15%" v-if="departmentList.length != 0 && ( objAuthorize.department_active == true || objAuthorize.department_active == 1 ) && props.item.department != null">
                  <v-tooltip bottom style="top: 0px !important;">
                    <p slot="activator" style="cursor:pointer;padding-top: 14px;float:left;display: block;">View Departments</p>
                    <span v-html="fncGetDepartment(props.item.department)"></span>
                  </v-tooltip>
                    <!--<p @click="fncShowDeparments()" style="text-decoration: underline;padding-top: 14px;">View Departments<p>-->
                    <!--<div class="departmentList" style="position:relative;display:none" v-html="fncGetDepartment(props.item.department)"></div>-->
                </td>
                <td width="10%"  :style="{ background: props.item.style_colour }"></td>
                <td width="10%"  v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1"><a @click.prevent="fncEditStatus(props.item.id, props.item.description)"><i class="material-icons">edit</i></a></td>
                <td width="10%"  v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1"><a @click.prevent="fncDeleteStatus(props.item.id, props.item.description, props.item.hasStatus)"><i class="material-icons">delete_forever</i></a></td>
              </tr>
              <tr class="sortableRow" id="rows" v-else style="display: none !important;">
                <td width="5%" class="px-1">
                  <v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
                </td>
                <td width="30%" v-if="departmentList.length == 0">{{ props.item.description }}</td>
                <td width="30%" v-else>{{ props.item.description }} - {{ props.item.show }}</td>
                <td width="20%"   v-if="fncGetPipelineGrouping(props.item)">{{fncGetPipelineGrouping(props.item)}}</td>
                <td width="20%"  v-else><span style="color: red;font-weight: 600;">Not Configured</span></td>
                <td width="15%" v-if="departmentList.length != 0">{{ fncGetDepartment(props.item.department) }}</td>
                <td width="10%"  :style="{ background: props.item.style_colour }">&nbsp;</td>
                <td width="10%"  v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1"><a @click.prevent="fncEditStatus(props.item.id, props.item.description)"><i class="material-icons">edit</i></a></td>
                <td width="10%"  v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1"><a @click.prevent="fncDeleteStatus(props.item.id, props.item.description, props.item.hasStatus)"><i class="material-icons">delete_forever</i></a></td>
              </tr>
            </template>
          </v-data-table>
        </div>
			</v-container>
		</v-content>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Sortable from 'sortablejs';

  export default {
	name: 'StatusList',
	intRoleEdit: 0,
    data () {
		return {
      department: window.localStorage.statusDepartment != undefined && window.localStorage.statusDepartment != null ? parseInt(window.localStorage.statusDepartment) : 0,
      statusListFiltered: [],
      departmentListNew: [{ id: 0, name: 'Showing statuses across all departments' }],
			search: '',
            headers: [
                { text: '', value: '', sortable: false, width: '5%' },
                { text: 'DESCRIPTION', value: 'description', sortable: false, width: '30%'  },
                { text: 'GENERAL STATUS FLAG', value: 'flag', sortable: false, width: '20%'  },
                { text: 'COLOUR', value: 'style_colour', sortable: false, width: '10%'  },
                { text: 'EDIT', value: 'edit', sortable: false, width: '10%'  },
                { text: 'DELETE', value: 'delete', sortable: false, width: '10%'  }
			],
      isDepartments: false,
      showStatusList: false,
      hasCheckedOut: false,
      hasCheckedOutText: ''
		}
	},
	methods: {
    fncGetPipelineGrouping(data){
      let string = []
      let pipeline = ['is_new_lead', 'is_gathering_customer_reqs', 'is_quote_sent', 'is_requote_requested', 'is_rejected', 'is_awaiting', 'is_reqs_sent_to_design_team',
        'is_quote_completed_by_design_team', 'is_accepted', 'is_cancel', 'is_expired', 'is_converted'
      ]
      for (let i in data){
        if (pipeline.includes(i) && data[i] === 'Yes'){
          switch (i) {
            case 'is_new_lead' :
              string.push('New Lead')
              break
            case 'is_gathering_customer_reqs':
              string.push('Gathering Customer Requirements')
              break
            case 'is_quote_sent':
              string.push('Quote Sent - Following Up')
              break
            case 'is_requote_requested':
              string.push('Requote Requested')
              break
            case 'is_rejected':
              string.push('Rejected')
              break
            case 'is_awaiting':
              string.push('Awaiting Acceptance')
              break
            case 'is_reqs_sent_to_design_team':
              string.push('Requirements Sent to Design Team')
              break
            case 'is_quote_completed_by_design_team':
              string.push('Quote Completed by Design team')
              break
            case 'is_accepted':
              string.push('Accepted Status')
              break
            case 'is_cancel':
              string.push('Cancelled Status')
              break
            case 'is_expired':
              string.push('Expired Status')
              break
            case 'is_converted':
              string.push('Converted')
              break
          }
        }
      }
      if (string.length > 0)
      {
        return string.join(', ')
      }
      else
        return null
    },
    fncShowDeparments() {

    },
	  fncShowStatusList(){
      if( this.showStatusList == true ) {
        if( ( this.departmentList.length == 1 || this.objAuthorize.department_active == true || this.objAuthorize.department_active == 1 ) ) {
            /*if( this.department != '' ) {
              return true;
            } else {
              return false;
            }*/
            return true;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    fncFilterStatuses(reload) {
	    this.$store.commit('fncDepartmentStatusFilter', parseInt(this.department));

	    // set local storage for department filter
      localStorage.setItem('statusDepartment', this.department);

      if( this.department == '' && reload == true ) {
        window.location.reload();
      }

      for( var s in this.statusList ) {
        if( this.departmentList.length == 0 || this.objAuthorize.department_active == false || this.objAuthorize.department_active == 0 ) {
          this.statusList[s].show = true;
        } else {
          if( this.department == 0 ) {
            if( this.statusList[s].department == null || this.statusList[s].department == 0 ) {
              this.statusList[s].show = true;
            }
          } else {
            if( this.statusList[s].department != null ) {
              var objDepartment = this.statusList[s].department.split(',');
            } else {
              var objDepartment = [];
            }
            if( objDepartment.indexOf(String(this.department)) != -1 ) {
            //if( this.statusList[s].department == this.department ) {
              this.statusList[s].show = true;
              //this.statusListFiltered.push( this.departmentList[s] );
            } else if( this.statusList[s].department == null && this.department == 0 ) {
              this.statusList[s].show = true;
            } else {
              this.statusList[s].show = false;
            }
          }
        }
      }
      this.showStatusList = true;

    },
    fncEditStatus( statusId, statusName ) {

      this.$store.dispatch({
        type: 'fncPopulateStatusListEdit',
        id: statusId,
        name: statusName,
        hasCheckedOut: this.hasCheckedOut,
        hasCheckedOutText: this.hasCheckedOutText
      });
      //this.$store.dispatch('fncPopulateStatusListEdit', statusId);
      /*this.$store.commit({
        type: 'setObjStatusEdit',
        id: statusId
      });
      var modalDetails = { title: 'Edit Status - ' + statusName, component: 'modal-status-edit', mstate: true, params: {statusId: statusId, statusName: statusName, hasCheckedOut: this.hasCheckedOut, hasCheckedOutText: this.hasCheckedOutText} };
      this.$store.commit({
        type: 'setModal',
        details: modalDetails
      });*/
    },
    fncDeleteStatus( statusId, statusName, hasStatus ) {
      if( hasStatus == null ) {
        var deleteConfirm = confirm('Are you sure you want to remove '+statusName+'?');
        if(deleteConfirm === true) {
          this.$store.dispatch({
            type: 'fncDeleteStatus',
            statusId: statusId
          })
        }
      } else {
        alert('CANNOT DELETE. There are quotes currently attached to this status.');
      }
    },
    fncReorderStatus({ oldIndex, newIndex }) {
      this.$store.dispatch({
        type: 'fncReorderStatus',
        start: oldIndex,
        end: newIndex
      });
    },
    fncGetDepartment(department) {
	    if( department != null ) {
        var departments = department.split( ',' );
      } else {
	      departments = [];
      }
      if( department == 0 || departments.length == 0 ) {
        return 'N/A';
      } else {
        var toAdd = [];
        for( var d in this.departmentList ) {
          if( departments.indexOf( String(this.departmentList[d].id) ) != -1 ) {
            toAdd.push(this.departmentList[d].name);
          }
        }
        return toAdd.join('<br />');
      }
    }
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'statusList',
			'globalModalParams',
      'departmentList',
      'departmentStatusFilter'
		])
	},
	beforeMount() {
	  this.$store.commit('fncEmptyStatusList');
	  this.$store.commit('fncEmptyDepartmentList');
		this.$store.dispatch('fncPopulateStatusList');
    this.$store.dispatch('fncPopulateDepartments');
	},
	created() {
		if( this.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') === -1 ) {
			this.headers = [
				{ text: 'Description', value: 'description' },
				{ text: 'Creates an Order', value: 'is_order_status' },
				{ text: 'Locks Quote', value: 'is_lock' },
				{ text: 'Triggers Notification', value: 'triggers_notification' },
				{ text: 'Tender Winning Status', value: 'is_tender_winning' },
				{ text: 'Creates an invoice', value: 'create_invoice' },
				{ text: 'Cancel Status', value: 'is_cancel' },
				{ text: 'Initial Tender Status', value: 'tender_status' },
				{ text: 'Colour', value: 'style_colour' },
				{ text: 'Flagged', value: 'colour_flag' },
				{ text: 'Accepted Status', value: 'is_accepted' },
				{ text: 'Expired Status', value: 'is_expired' }
			]
		}
    },
    mounted() {
      for( var s in this.statusList ) {
        if( this.statusList[s].is_checked == true || this.statusList[s].is_checked == 1 || this.statusList[s].is_checked == 'Yes' ) {
          this.hasCheckedOut = true;
          this.hasCheckedOutText = this.statusList[s].description;
        }
      }
      if( this.$store.getters.departmentList.length == 0 ) {
        for( var s in this.statusList ) {
          this.statusList[s].show = true;
        }
        this.showStatusList = true;
      }
      if( this.$store.getters.departmentList.length > 0 && ( this.objAuthorize.department_active == true || this.objAuthorize.department_active == 1 ) ) {
        this.isDepartments = true;
        this.headers = [
          { text: '', value: '', sortable: false, width: '5%' },
          { text: 'DESCRIPTION', value: 'description', sortable: false, width: '35%'  },
          { text: 'GENERAL STATUS FLAG', value: 'flag', sortable: false, width: '20%'  },
          { text: 'DEPARTMENT', value: 'branch', sortable: false, width: '15%'  },
          { text: 'COLOUR', value: 'style_colour', sortable: false, width: '15%'  },
          { text: 'EDIT', value: 'edit', sortable: false, width: '15%'  },
          { text: 'DELETE', value: 'delete', sortable: false, width: '15%'  }
        ];
        for( var d in this.departmentList ) {
          this.departmentListNew.push(this.departmentList[d])
        }
      }
      new Sortable(
        this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          onUpdate: this.fncReorderStatus
        }
      )
    },
      watch: {
          departmentList() {
              if( this.departmentList.length > 0 && ( this.objAuthorize.department_active == true || this.objAuthorize.department_active == 1 ) ) {
                  this.isDepartments = true;
                  this.headers = [
                      { text: '', value: '', sortable: false, width: '5%' },
                      { text: 'DESCRIPTION', value: 'description', sortable: false, width: '30%'  },
                      { text: 'GENERAL STATUS FLAG', value: 'flag', sortable: false, width: '20%'  },
                      { text: 'DEPARTMENT', value: 'branch', sortable: false, width: '15%'  },
                      { text: 'COLOUR', value: 'style_colour', sortable: false, width: '10%'  },
                      { text: 'EDIT', value: 'edit', sortable: false, width: '10%'  },
                      { text: 'DELETE', value: 'delete', sortable: false, width: '10%'  }
                  ];

                  for( var d in this.departmentList ) {
                    this.departmentListNew.push(this.departmentList[d])
                  }
              }
          },
          statusList() {
            for( var s in this.statusList ) {
              if( this.statusList[s].is_checked == true || this.statusList[s].is_checked == 1 || this.statusList[s].is_checked == 'Yes' ) {
                this.hasCheckedOut = true;
                this.hasCheckedOutText = this.statusList[s].description;
              }
            }
            if( this.departmentList.length == 0 ) {
              for( var s in this.statusList ) {
                this.statusList[s].show = true;
              }
              this.showStatusList = true;
            } else {
                for( var d in this.departmentList ) {
                  this.statusListFiltered.push(this.departmentList[d])
                }
            }
            //if( this.department > 0 ) {
              this.fncFilterStatuses(false);
            //}
          }
      }
}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>
